// Angular
import { Injectable } from '@angular/core';

// Service
import { SoledadAuthenticationService } from '../../../shared/services/b2b/auth.service';

// Auth
import * as loginActions from '../login/login.actions';
import * as cartActions from '../../cart/cart.actions';
import * as searchActions from './../../dashboard/search/search.actions';

// Ngrx
import { Action, Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';

// Rxjs
import { Observable } from 'rxjs';
import { of } from 'rxjs';

import { catchError, mergeMap, switchMap } from 'rxjs/operators';
import { AppState } from '../..';

@Injectable()
export class LoginEffects {
    constructor(
        private authService: SoledadAuthenticationService,
        private actions$: Actions,
        private store: Store<AppState>
    ) {}

    login$: Observable<Action> = createEffect(() =>
        this.actions$.pipe(
            ofType(loginActions.LoginActionTypes.DO_LOGIN_USER),
            mergeMap((action: loginActions.DoLoginUser) =>
                this.authService.login(action.payload).pipe(
                    mergeMap((response) => [
                        new loginActions.DoLoginUserSuccess(response),
                        // new routerActions.Go({ path: ['/dashboard'] }) // Puedes agregar esta acción si es necesaria.
                    ]),
                    catchError((error) => of(new loginActions.DoLoginUserFail(error)))
                )
            )
        )
    );

    logout$: Observable<Action> = createEffect(() =>
        this.actions$.pipe(
            ofType(loginActions.LoginActionTypes.DO_LOGOUT),
            switchMap((action: loginActions.DoLogout) => {
                this.store.dispatch(new loginActions.DoLoginUserReset());
                this.store.dispatch(new cartActions.DoClear());
                this.store.dispatch(new searchActions.DoClearSearch());
                this.authService.logout();
                return [];
            })
        )
    );
}
